'use strict';
/* ==========================================================================
   core-local/hooks.js — "Balance It": this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks). The maths cast, reused (DESIGN.md §3).

   completeCard: the BALANCED card's two lines (see below).
   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js), from the notebook
             pack's palette (docs/NOTEBOOK.md §2): Ms. Rivera = red pen (her pen does the marking), Jay = ballpoint ink.
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   Puppets: rivera (rivera, rivera_point), jay (jay, jay_point): the line art of lessons/tails-due (copied into
            assets/img/). Facing (Puppet.NATIVE), as in tails-due: jay and jay_point face the front (0, never
            mirrored); both rivera poses are +1 (rivera_point points to the viewer's RIGHT). In the video Jay stands on
            the LEFT, Rivera on the RIGHT facing −1 (mirrored: her point aims left at Jay and the working); the title
            and the map draw her facing +1 (unmirrored).
   ========================================================================== */
window.LessonHooks = {
  speakers: { rivera: { name: 'Ms. Rivera', color: '#d23f33' }, jay: { name: 'Jay', color: '#1d2b4f' } },
  /* the BALANCED card: the finished step's card.done + where to go next. lesson.json's steps[].card.next describes
     the step AFTER that step ("video" → "Next: Red Pen (tag 2)."), so the next line is the finished step's own
     card.next when the first unstamped step is the one right after it; otherwise "Next: <title> (tag k)." */
  completeCard(stepId, progress) {
    const L = (window.Game && Game.lesson) || {}, steps = L.steps || [], C = L.completeCard || {}, st = progress.stamps || {};
    const me = steps.find(s => s.id === stepId) || {};
    const done = (me.card && me.card.done) || 'Balanced.';
    const k = steps.findIndex(s => !st[s.id]);
    let next;
    if (k < 0) next = C.allDone || 'All four balanced!';
    else {
      const prev = steps[k - 1];
      next = prev && prev.id === stepId && prev.card && prev.card.next ? prev.card.next : `Next: ${steps[k].title || steps[k].id} (tag ${k + 1}).`;
    }
    return { title: C.title || 'BALANCED', lines: [done, next] };
  },
  captions({ script }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    return { text, who };
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; the first/default pose per character) */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  P.POSES.rivera = { rivera: 'rivera', point: 'rivera_point', rivera_point: 'rivera_point' };
  P.POSES.jay = { jay: 'jay', point: 'jay_point', jay_point: 'jay_point' };
  P.DEFAULT.rivera = 'rivera'; P.DEFAULT.jay = 'jay';
  Object.assign(P.NATIVE, { rivera: 1, rivera_point: 1, jay: 0, jay_point: 0 });
})();
